import { OfflineAppointment } from "../../firestore/types";
import { appointmentStatusForActiveAppointments } from "../constants";

export const getActiveAppointmentsOnly = (
  allAppointments: OfflineAppointment[]
) => {
  return allAppointments.filter((i) =>
    appointmentStatusForActiveAppointments.includes(i.status)
  );
};
